import React, { createContext, useContext } from "react";

interface PageInfo {
  id: string;
  path: string;
  title: string;
}

interface PagesContextValue {
  pages: PageInfo[];
}

const PagesContext = createContext<PagesContextValue | undefined>(undefined),

  usePages = (): PagesContextValue => {
    const context = useContext(PagesContext);
    if (!context) {
      throw new Error("usePages must be used within PagesProvider");
    }
    return context;
  };

interface PagesProviderProps {
  pages: PageInfo[];
  children: React.ReactNode;
}

const PagesProvider: React.FC<PagesProviderProps> = ({ pages, children }) => <PagesContext.Provider value={{ pages }}>{children}</PagesContext.Provider>;

export type { PageInfo };
export { usePages, PagesProvider };
